module.exports = __webpack_public_path__ + "static/img/meter.ccb4f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/company/meter.png
// module id = +Iav
// module chunks = 3